export default __webpack_public_path__ + "static/media/tasbih.27d704c5.svg";